// extracted by mini-css-extract-plugin
module.exports = {"address":"Information_address__2fafN","label":"Information_label__1dHPG","dateValue":"Information_dateValue__37xl4","datepicker":"Information_datepicker__2K3ZP"};